import React from 'react';
import { IMPORT_STATUS } from '../../services/shopperPayoutService';

const IMPORT_STATUS_META = {
  [IMPORT_STATUS.PENDING]: {
    label: 'Pending',
    className: 'bg-gray-100 text-gray-800',
  },
  [IMPORT_STATUS.VALIDATING]: {
    label: 'Validating',
    className: 'bg-blue-100 text-blue-800',
  },
  [IMPORT_STATUS.VALIDATED]: {
    label: 'Validated',
    className: 'bg-indigo-100 text-indigo-800',
  },
  [IMPORT_STATUS.PROCESSING]: {
    label: 'Processing',
    className: 'bg-blue-100 text-blue-800',
  },
  [IMPORT_STATUS.COMPLETED]: {
    label: 'Completed',
    className: 'bg-green-100 text-green-800',
  },
  [IMPORT_STATUS.COMPLETED_WITH_ERRORS]: {
    label: 'Completed with Errors',
    className: 'bg-amber-100 text-amber-800',
  },
  [IMPORT_STATUS.FAILED_INCOMPLETE]: {
    label: 'Failed / Incomplete',
    className: 'bg-red-100 text-red-800',
  },
  [IMPORT_STATUS.CANCELED]: {
    label: 'Canceled',
    className: 'bg-gray-100 text-gray-600',
  },
};

const ROW_RESULT_META = {
  valid: { label: 'Valid', className: 'bg-green-100 text-green-800' },
  invalid: { label: 'Invalid', className: 'bg-red-100 text-red-800' },
};

const META_BY_KIND = {
  import: IMPORT_STATUS_META,
  result: ROW_RESULT_META,
};

/**
 * Coloured pill used for import status and row validation result. Unknown
 * values fall back to the raw string so a new backend status is still readable
 * instead of disappearing.
 */
const StatusBadge = ({ value, kind = 'import', className = '' }) => {
  if (!value) return <span className='text-sm text-gray-400'>-</span>;

  const meta = META_BY_KIND[kind] || IMPORT_STATUS_META;
  const config = meta[value] || {
    label: value,
    className: 'bg-gray-100 text-gray-800',
  };

  return (
    <span
      className={`inline-flex px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
export { IMPORT_STATUS_META };
